import React from 'react';
import MultiSelect from 'global/react-mui/atoms/MultiSelect';
import { useDispatch, useSelector } from 'react-redux';
import { partnerCategoriesSelector, selectedPartnerCategoriesSelector } from '../../../store/modules/filters/selectors';
import { filtersSliceActions } from '../../../store/modules/filters/reducer';
import { ListItemText, MenuItem } from '@material-ui/core';
import Checkbox from 'global/react-mui/atoms/Checkbox';
import IconRenderer from 'global/react-mui/atoms/IconRenderer';
import { partnerProfileDrawerIsOpenSelector } from '../../../store/modules/ui/selectors';
import { translationsSelector } from '../../../store/modules/translations/selectors';

const SelectCategory: React.FC<Record<string, unknown>> = () => {
	const dispatch = useDispatch();
	const partnerCategories = useSelector(partnerCategoriesSelector);
	const selectedPartnerCategories = useSelector(selectedPartnerCategoriesSelector);
	const isPartnerDrawerVisible = useSelector(partnerProfileDrawerIsOpenSelector);
	const { chooseCategoryPlaceholder, searchFilterCategoriesPlaceholder } = useSelector(translationsSelector);

	const handleSelectChange = (value) => {
		dispatch(filtersSliceActions.setPartnerCategoryType(value));
	};

	return (
		<MultiSelect
			id="partner-categories"
			label={searchFilterCategoriesPlaceholder}
			options={partnerCategories}
			selectedOptions={selectedPartnerCategories}
			handleSelectChange={handleSelectChange}
			placeholder={chooseCategoryPlaceholder}
			disabled={isPartnerDrawerVisible}
			formControlProps={{ width: '100%', mt: 2, mx: 0 }}
			renderOptions={(option) => (
				<MenuItem key={option.label} value={option.value}>
					<Checkbox style={{ marginRight: '4px' }} checked={selectedPartnerCategories?.includes(option.value)} />
					<IconRenderer icon={option.icon} shape="squared" bgColor="#E0E0E0" color="#A7A7A7" boxProps={{ marginRight: '8px' }} />
					<ListItemText primary={option.label} />
				</MenuItem>
			)}
		/>
	);
};

export default SelectCategory;
